//---------------[GLOBAL VARIABLES]---------------//
//[project info]
export const ProjectName = process.env.REACT_APP_FB_PROJECT_ID || "innsamling-tutti";
export const ProjectUrl = process.env.REACT_APP_PUBLIC_URL || "https://www.dugnad.org/";


//[roles]
export const managerRoles = [
  "campaign_admin",
  "manager_admin",
];//from least to most weight


//[image formats]
export const imageFormats = [
  "png", "jpg", "jpeg", "webp",
  "image/png", "image/jpg", "image/jpeg", "image/webp",
];
//[image sizes]


//---------------[REGEX]----------------//
//[url] website url
export const regEx_url = /^((https?):\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&\/=]*)$/i
export const regEx_urlEmpty = /^((https?):\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&\/=]*)$|(^$)/i


//[email] email address
export const regEx_email = /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$)/;
export const regEx_emailEmpty = /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$)|(^$)/;

//[username] phone number or email address
export const regEx_username = /((\+)?\d+)|(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$)/;


//-----------[TYPE UTILS]-------------//
export type Edit<Origin, Edit> = Omit<Origin, keyof Edit> & Edit;
export type ListifiedData<T> = T & Record<string, any>;
